import { ModalHost } from "~/shared_states/modal";

export default function ClientOnlyModalHost() {
  return <ModalHost />;
}
